export enum EActionTypes {
  buy = 'buy',
  sell = 'sell',
  deposit = 'deposit',
  withdraw = 'withdraw',
}
